import React from "react";
import "../styles/components/pagination.css";
import PaginationArrowIcon from "../assets/icons/pagination-arrow-icon.svg";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <div className="pagination">
      <button
        className="arrow-btn"
        style={{ visibility: currentPage > 1 ? "visible" : "hidden" }}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <img
          src={PaginationArrowIcon}
          alt="Предыдущая страница"
          className="pagination-icon rotated-icon"
        />
      </button>

      {[...Array(totalPages)].map((_, index) => (
        <button
          key={index}
          className={`page-btn ${currentPage === index + 1 ? "active" : ""}`}
          onClick={() => onPageChange(index + 1)}
        >
          {index + 1}
        </button>
      ))}

      <button
        className="arrow-btn"
        style={{ visibility: currentPage < totalPages ? "visible" : "hidden" }}
        onClick={() => onPageChange(currentPage + 1)}
      >
        <img
          src={PaginationArrowIcon}
          alt="Следующая страница"
          className="pagination-icon"
        />
      </button>
    </div>
  );
};

export default Pagination;
